import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconCircleX } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';
import { isRunningJob, TransformedActivity } from '../../helpers';
import { useCancelRun } from '../../hooks/useCancelRun';
import { useRunCancelState } from '../../hooks/useRunCancelState';
import { CancelActivityDialog } from './CancelActivityDialog';

type CancelActivityColumnProps = TransformedActivity;

export const CancelActivityColumn = (run: CancelActivityColumnProps) => {
  const [open, setOpen] = useState(false);

  const intl = useIntl();

  const { mutate } = useCancelRun();

  const handleClose = () => setOpen(false);

  const { isCancelling, isCancelRequestTimedOut } = useRunCancelState(run);

  const { uuid, status, hookType } = run;

  if (
    hookType !== 'job' ||
    !uuid ||
    !isRunningJob(status) ||
    (isCancelling && !isCancelRequestTimedOut)
  ) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={intl.formatMessage({
          id: 'features.activities.cancelActivity.cancel',
        })}
        placement="top"
      >
        <IconButton
          onClick={e => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <SvgIcon fontSize="medium" color="action">
            <IconCircleX />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <CancelActivityDialog
        open={open}
        onClose={handleClose}
        onConfirm={() => {
          mutate({ runUuid: uuid });
          handleClose();
        }}
      />
    </>
  );
};
